import "antd/lib/card/style";
import _Card from "antd/lib/card";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/tabs/style";
import _Tabs from "antd/lib/tabs";
import "antd/lib/select/style";
import _Select from "antd/lib/select";
import React from 'react';
import './index.scss';
import * as echarts from 'echarts';
import moment from "moment";
import AgencyFlowStat from "./subComponents/AgencyFlowStat";
import AppFlowStat from "./subComponents/AppFlowStat";
import CustomAppFlowStat from "./subComponents/CustomAppFlowStat";
import { parse } from '../../../utils/commonUtilFunc';
import { chartColor } from "../../../utils/commonConsts";
import { injectIntl } from "react-intl";
var Option = _Select.Option;
var TabPane = _Tabs.TabPane;
var CI0301 = /*#__PURE__*/function (_React$Component) {
  _inherits(CI0301, _React$Component);
  function CI0301(props) {
    var _this;
    _classCallCheck(this, CI0301);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CI0301).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectTimeInterval", function (value) {
      var start_tm_temp = "";
      var end_tm_temp = moment().format("YYYY-MM-DD HH:mm:ss");
      switch (value) {
        case "0":
          start_tm_temp = moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "1":
          start_tm_temp = moment().subtract(6, "hours").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "2":
          start_tm_temp = moment().subtract(24, "hours").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "3":
          start_tm_temp = moment().subtract(7, "days").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "4":
          start_tm_temp = moment().subtract(1, "months").format("YYYY-MM-DD HH:mm:ss");
          break;
        default:
          start_tm_temp = moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss");
      }
      _this.setState({
        start_tm: start_tm_temp,
        end_tm: end_tm_temp
      }, function () {
        switch (this.state.tabSelected) {
          case "1":
            this.getDataA();
            break;
          case "2":
            this.getDataB();
            break;
          case "3":
            this.getDataC();
            break;
          default:
            break;
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectTimeRange", function (dateValue) {
      _this.setState({
        start_tm: dateValue[0].format("YYYY-MM-DD HH:mm:ss"),
        end_tm: dateValue[1].format("YYYY-MM-DD HH:mm:ss")
      }, function () {
        switch (this.state.tabSelected) {
          case "1":
            this.getDataA();
            break;
          case "2":
            this.getDataB();
            break;
          case "3":
            this.getDataC();
            break;
          default:
            break;
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectDataNum", function (value) {
      _this.setState({
        data_num: value
      }, function () {
        switch (this.state.tabSelected) {
          case "1":
            this.getDataA();
            break;
          case "2":
            this.getDataB();
            break;
          case "3":
            this.getDataC();
            break;
          default:
            break;
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tabChange", function (activeKey) {
      switch (activeKey) {
        case "1":
          _this.getDataA();
          _this.setState({
            tabSelected: "1"
          });
          break;
        case "2":
          _this.getDataB();
          _this.setState({
            tabSelected: "2"
          });
          break;
        case "3":
          _this.getDataC();
          _this.setState({
            tabSelected: "3"
          });
          break;
        default:
          break;
      }
    });
    _this.state = {
      start_tm: moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss"),
      end_tm: moment().format("YYYY-MM-DD HH:mm:ss"),
      timeInterval: "",
      data_num: 5,
      appName: "",
      tabSelected: "1"
    };
    var companyid = "";
    if (parse(_this.props.location.search).id) {
      companyid = parse(_this.props.location.search).id;
    } else {
      companyid = parseInt(sessionStorage.getItem("companyId"));
    }
    _this.companyid = companyid;
    return _this;
  }
  _createClass(CI0301, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.histogramElA = echarts.init(document.getElementById("chartA"));
      this.renderBandLine(this.histogramElA, "带宽(Mbps)");
      this.getDataA();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderBandLine(this.histogramElA, "带宽(Mbps)");
    }
  }, {
    key: "getDataA",
    value: function getDataA() {
      this.props.dispatch({
        type: "ci0301Info/getStatisticsA",
        payload: {
          item: "appBand",
          companyid: this.companyid,
          start_tm: this.state.start_tm,
          end_tm: this.state.end_tm,
          top: this.state.data_num
        }
      });
    }
  }, {
    key: "getDataB",
    value: function getDataB() {
      this.props.dispatch({
        type: "ci0301Info/getStatisticsB",
        payload: {
          item: "steps",
          companyid: this.companyid,
          start_tm: this.state.start_tm,
          end_tm: this.state.end_tm,
          top: this.state.data_num
        }
      });
    }
  }, {
    key: "getDataC",
    value: function getDataC() {
      this.props.dispatch({
        type: "ci0301Info/getStatisticsC",
        payload: {
          item: "appBand",
          companyid: this.companyid,
          start_tm: this.state.start_tm,
          end_tm: this.state.end_tm,
          top: this.state.data_num,
          defined: true
        }
      });
    }
  }, {
    key: "renderBandLine",
    value: function renderBandLine(el) {
      var histogram = el;
      histogram.clear();
      var option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: "#333",
          extraCssText: 'box-shadow: 0 2px 2px 0 rgba(24,24,24,0.60);border-radius: 2px 2px 0 0 0 2px 2px;',
          formatter: function formatter(data) {
            var res = '';
            for (var i = 0; i < data.length; i++) {
              res += '<tr><td><span style="font-size:32px;color:' + data[i].color + '">&middot;</span>' + data[i].seriesName + '</td><td>' + data[i].data[1] + '<td/><td>' + data[i].data[0] + '</td></tr>';
            }
            return '<div class="line-tooltip"><table class="line-tooltip-table" style="border-bottom: none">' + res + '<table/></div>';
          }
        },
        grid: {
          bottom: '20%'
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          min: this.state.start_tm,
          max: this.state.end_tm,
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,0.45)"
            }
          }
        },
        legend: {
          left: "center",
          bottom: 0,
          icon: "circle"
        },
        yAxis: [{
          type: 'value',
          name: '@速率(Mbps)',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        }],
        series: this.props.ci0301Info.lineSeriesA,
        color: chartColor
      };
      histogram.setOption(option);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Card, {
        className: "card"
      }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement(_Select, {
        placeholder: "@请选择时间间隔",
        style: {
          width: 200,
          marginRight: 8
        },
        className: "input",
        onChange: this.selectTimeInterval,
        defaultValue: "0"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "0",
        key: "0"
      }, "@\u6700\u8FD130\u5206\u949F"), /*#__PURE__*/React.createElement(Option, {
        value: "1",
        key: "1"
      }, "@\u6700\u8FD16\u5C0F\u65F6"), /*#__PURE__*/React.createElement(Option, {
        value: "2",
        key: "2"
      }, "@\u6700\u8FD1\u4E00\u5929"), /*#__PURE__*/React.createElement(Option, {
        value: "3",
        key: "3"
      }, "@\u6700\u8FD1\u4E00\u5468")), /*#__PURE__*/React.createElement(_Select, {
        placeholder: "@请选择数据条数",
        style: {
          width: 120,
          marginRight: 8
        },
        className: "input",
        onChange: this.selectDataNum,
        defaultValue: "5"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "5"
      }, "@5\u6761"), /*#__PURE__*/React.createElement(Option, {
        value: "10"
      }, "@10\u6761"), /*#__PURE__*/React.createElement(Option, {
        value: "15"
      }, "@15\u6761"), /*#__PURE__*/React.createElement(Option, {
        value: "20"
      }, "@20\u6761"))), /*#__PURE__*/React.createElement(_Tabs, {
        defaultActiveKey: "1",
        onChange: this.tabChange
      }, /*#__PURE__*/React.createElement(TabPane, {
        tab: "@中心节点",
        key: "1"
      }, /*#__PURE__*/React.createElement(AppFlowStat, {
        start_tm: this.state.start_tm,
        end_tm: this.state.end_tm,
        data_num: this.state.data_num,
        companyid: this.companyid
      })), /*#__PURE__*/React.createElement(TabPane, {
        tab: "@边缘节点",
        key: "2"
      }, /*#__PURE__*/React.createElement(AgencyFlowStat, {
        start_tm: this.state.start_tm,
        end_tm: this.state.end_tm,
        data_num: this.state.data_num,
        companyid: this.companyid
      })), /*#__PURE__*/React.createElement(TabPane, {
        tab: "@自定义",
        key: "3"
      }, /*#__PURE__*/React.createElement(CustomAppFlowStat, {
        start_tm: this.state.start_tm,
        end_tm: this.state.end_tm,
        data_num: this.state.data_num,
        companyid: this.companyid
      })))));
    }
  }]);
  return CI0301;
}(React.Component);
export default injectIntl(CI0301);